import {Component, OnInit, Input} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {TypesService, FormBuilderService} from '../../../services';
import {IndividualExpenseModel} from '../../../models/widgets/expenses-details-model';
import * as _ from 'lodash';
import {Decimal} from 'decimal.js';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgFor, NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import {
  FurtherAdvanceConfirmationComponent
} from '../further-advance-confirmation/further-advance-confirmation.component';


@Component({
    selector: 'app-expenses-details',
    templateUrl: './expenses-details.component.html',
    styles: [],
    standalone: true,
  imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, NgFor, MatFormFieldModule, MatFormFieldModule, MatInputModule, MatInputModule, MatSelectModule, MatSelectModule, MatOptionModule, MatOptionModule, NgIf, FurtherAdvanceConfirmationComponent]
})

export class ExpensesDetailsComponent extends WizardWidgetComponent implements OnInit {
  @Input() public faType: string;
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isFurtherAdvance = false;

  public expenseTypes: any;
  public expensesFormArray: any;
  public removableFlags = [];
  public expenses = [];

  constructor(public dataHandlerService: DataHandlerService,
              private formBuilderService: FormBuilderService,
              public formBuilder: UntypedFormBuilder,
              public typesService: TypesService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.typesService.getTypesList('expense-types')
      .then((results: any) => {

        const sortedItems = _.sortBy(results, function (result) {
          return result.id === 'general-living-expense' ? 0 : 1;
        });

        this.expenseTypes = sortedItems;
        !this.formGroup.get('expensesList') && this.formGroup.setControl('expensesList', this.formBuilder.array([]));
        this.expensesFormArray = this.formGroup.get('expensesList');
        this.initExpenses();
      });
  }

  public initExpenses() {
    const existingExpenses = this.expensesFormArray ? this.expensesFormArray.value : null;
    if (existingExpenses) {
      if (existingExpenses.length === 0) {
        this.expenseTypes.forEach((type) => {
          this.addExpense(type.id);
        });
      } else {
        // clear expenses and add them one by one
        while (this.expensesFormArray.length) {
          this.expensesFormArray.removeAt(0);
        }
        this.expenseTypes.forEach((type) => {
          this.addExpense(type.id, existingExpenses.find(e => e.type === type.id));
        });
        // add flags after refresh
        for (let i = 0; i < existingExpenses.length; i++) {
          if (i < this.expenseTypes.length) {
            this.removableFlags.push(false);
          } else {
            this.removableFlags.push(true);
          }
        }
      }
      this.computeTotalExpenses();
    }
  }

  public addExpense(id, data = null) {
    const expense = new IndividualExpenseModel();
    if (id) {
      expense.type.value = id;
      this.removableFlags.push(false);
      const expenseType = this.expenseTypes.find(x => x.id === id);

      this.expenses.push(expenseType);
    } else {
      this.removableFlags.push(true);
    }
    const fg = this.formBuilderService.convertObjectToFormGroup(expense);
    this.formBuilderService.setValidationRules(new IndividualExpenseModel(), fg);

    if (fg.get('type').value === 'general-living-expense') {
      fg.get('amount').setValidators(Validators.compose([Validators.min(1), Validators.required, Validators.pattern('^[0-9\.]*$')]));
      fg.get('amount').updateValueAndValidity();
    }

    this.expensesFormArray.push(fg);
    if (data) {
      fg.patchValue(data);
    }
  }

  public computeTotalExpenses() {
    let total = new Decimal(0);
    this.expensesFormArray.controls.forEach((expense) => {
      if (expense.valid) {
        total = total.add(expense.value.amount || 0);
      }
    });
    this.formGroup.get('totalExpensesValue').patchValue(total.toNumber());
  }
}
